module.exports = __webpack_public_path__ + "img/tenjin.png";